import { FeedbackFilters } from 'shared/components/Feedback/FeedbackDashboardFilterBar';
import {
  DonorGroup,
  FilterGroups,
  ManagerGroup,
  ProgramGroup,
  ReportsCountResponse,
  YearGroup,
} from './api';

export interface Report {
  contributionAmount: number;
  id: number;
  imageUrl: string;
  nextTask: { name: string; due: string };
  organization: string;
  program: string;
  programUrl: string;
  reach: string;
  service: string;
  stage: string;
  status: string;
  year: number;
}

type FinancialRow = {
  budget?: number;
  totalDonations?: number;
};

export const calculateDonationPercent = ({
  budget = 0,
  totalDonations = 0,
}: FinancialRow): string => {
  if (totalDonations <= 0 || budget <= 0) {
    return '0%';
  }

  const percentage = Math.min(100, (totalDonations / budget) * 100);

  return `${percentage.toFixed(2)}%`;
};

export const reportFilterKeys = [
  'Program',
  'Year',
  'Donor',
  'Manager',
] as const;

export const defaultReportFilters = (): FeedbackFilters => ({
  Program: {
    name: 'Program',
    value: 'program',
    selected: true,
  },
  Year: {
    name: 'Year',
    value: 'year',
  },
  Donor: {
    name: 'Donor',
    value: 'donor',
  },
  Manager: {
    name: 'Manager',
    value: 'manager',
  },
});

export const reportQuickFilterKeys = [
  'All',
  'My Reports Only',
  'Include Archived',
] as const;
export const defaultReportQuickFilters = (): FeedbackFilters => ({
  All: {
    name: 'All',
    value: 'all',
    selected: true,
  },
  'My Reports Only': {
    name: 'My Reports Only',
    value: 'My Reports Only',
  },
  'Include Archived': {
    name: 'Include Archived',
    value: 'Include Archived',
  },
});

export type ReportGroups = YearGroup | ProgramGroup | DonorGroup | ManagerGroup;

export const getReportGroups = (
  response: ReportsCountResponse | null,
): ReportGroups[] => {
  if (!response) return [];
  return (
    response['reportsCountByYear'] ||
    response['programReportCount'] ||
    response['donorReportCount'] ||
    response['managerReportCount']
  );
};

export const getTotalReport = (
  response: ReportsCountResponse | null,
): number => {
  let count = 0;
  if (!response) return 0;
  const list = getReportGroups(response);

  list.forEach(l => {
    count += l.count;
  });
  return count;
};

export const getReportGroupName = (
  item: ReportGroups | FilterGroups[0],
): string | number => {
  return item['year'] || item['program'] || item['donor'] || item['manager'];
};
